import BasicLayout from '@/layouts/basic-layout'

const meta = {
  auth: false,
  cache: true,
}

export default {
  path: '/form/tax',
  name: 'tax',
  redirect: {
    name: 'invoiceInfo',
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: '/form/tax/invoiceInfo',
      name: 'invoiceInfo',
      meta: {
        ...meta,
        title: '待审核单据详情',
        desc: '待审核单据详情',
      },
      component: () => import('@/pages/form/tax/invoiceInfo.vue'),
    },
    {
      path: '/form/tax/fapiaosArchivedInfo',
      name: 'fapiaosArchivedInfo',
      meta: {
        ...meta,
        title: '待开票单据详情',
        desc: '待开票单据详情',
      },
      component: () => import('@/pages/form/tax/fapiaosArchivedInfo.vue'),
    },
    {
      path: '/form/tax/fapiaoForYunying',
      name: 'fapiaoForYunying',
      meta: {
        ...meta,
        title: '运营查看发票信息',
        desc: '运营查看发票信息',
      },
      component: () => import('@/pages/form/tax/fapiaoForYunying.vue'),
    },
    {
      path: '/form/tax/DownloadFileScript',
      name: 'DownloadFileScript',
      meta: {
        ...meta,
        title: '下载资料',
        desc: '下载资料',
      },
      component: () => import('@/pages/form/tax/DownloadFileScript.vue'),
    },
    {
      path: '/form/tax/fapiaosDeniedInfo',
      name: 'fapiaosDeniedInfo',
      meta: {
        ...meta,
        title: '归档标据详情',
        desc: '归档标据详情',
      },
      component: () => import('@/pages/form/tax/fapiaosDeniedInfo.vue'),
    },
    {
      path: '/form/tax/waitForKaipiaoInfo',
      name: 'waitForKaipiaoInfo',
      meta: {
        ...meta,
        title: '驳回单详情',
        desc: '驳回单详情',
      },
      component: () => import('@/pages/form/tax/waitForKaipiaoInfo.vue'),
    },
    {
      path: '/form/tax/FapiaosCancelled',
      name: 'FapiaosCancelledInfo',
      meta: {
        ...meta,
        title: '作废单详情',
        desc: '作废单详情',
      },
      component: () => import('@/pages/form/tax/FapiaosCancelledInfo.vue'),
    },
    {
      path: '/abcd/tax/taxindex',
      name: 'taxindex',
      meta: {
        ...meta,
        title: '税务主页',
        desc: '税务主页',
      },
      component: () => import('@/pages/form/tax/taxindex.vue'),
    },
    {
      path: '/abcd/tax/orderList',
      name: 'orderList',
      meta: {
        ...meta,
        title: '运单列表',
        desc: '运单列表',
      },
      component: () => import('@/pages/form/tax/orderList.vue'),
    },
    {
      path: '/abcd/tax/orderInfo',
      name: 'orderInfo',
      meta: {
        ...meta,
        title: '运单详情',
        desc: '运单详情',
      },
      component: () => import('@/pages/form/tax/orderInfo.vue'),
    },
    {
      path: '/abcd/tax/trafficStatistics',
      name: 'orderInfo',
      meta: {
        ...meta,
        title: '运量统计',
        desc: '运量统计',
      },
      component: () => import('@/pages/form/tax/trafficStatistics.vue'),
    },
    {
      path: '/abcd/tax/shipTraffic',
      name: 'orderInfo',
      meta: {
        ...meta,
        title: '船舶运输数量',
        desc: '船舶运输数量',
      },
      component: () => import('@/pages/form/tax/shipTraffic.vue'),
    },
    {
      path: '/abcd/tax/freightStatistics',
      name: 'orderInfo',
      meta: {
        ...meta,
        title: '运费统计',
        desc: '运费统计',
      },
      component: () => import('@/pages/form/tax/freightStatistics.vue'),
    },
    {
      path: '/abcd/tax/VipList',
      name: 'VipList',
      meta: {
        ...meta,
        title: '会员列表',
        desc: '会员列表',
      },
      component: () => import('@/pages/form/tax/VipList.vue'),
    },
    {
      path: '/abcd/tax/firmList',
      name: 'firmList',
      meta: {
        ...meta,
        title: '企业列表',
        desc: '企业列表',
      },
      component: () => import('@/pages/form/tax/firmList.vue'),
    },
    {
      path: '/abcd/tax/ship_in_transit',
      name: 'firmList',
      meta: {
        ...meta,
        title: '企业列表',
        desc: '企业列表',
      },
      component: () => import('@/pages/form/tax/ship_in_transit.vue'),
    },
    {
      path: '/abcd/tax/taxHome',
      name: 'taxHome',
      meta: {
        ...meta,
        title: '查询首页',
        desc: '查询首页',
      },
      component: () => import('@/pages/form/tax/taxHome.vue'),
    },
  ],
}
